import { SignupStep } from '#sign-up/components/SignUp/types';
import { SignUpStepIndicator } from '#sign-up/components/SignUpStepIndicator/SignUpStepIndicator';

const STEP_ITEMS = [
  { step: SignupStep.MainContact, label: 'Main Contact' },
  { step: SignupStep.Company, label: 'Company' },
  { step: SignupStep.Controllers, label: 'Controllers' },
  { step: SignupStep.Accounts, label: 'Accounts' },
  { step: SignupStep.Finish, label: 'Finish' },
];

interface SignUpTimelineProps {
  currentStep: SignupStep;
  onStepChange: (step: SignupStep) => void;
  allStepsCompleted?: boolean;
}

export const SignUpTimeline = ({ currentStep, onStepChange, allStepsCompleted = false }: SignUpTimelineProps) => {
  return (
    <div className="signup-steps">
      {STEP_ITEMS.map(({ step, label }) => (
        <SignUpStepIndicator
          key={step}
          completed={allStepsCompleted || currentStep > step}
          step={step}
          currentStep={currentStep}
          onStepChange={allStepsCompleted ? undefined : onStepChange}
        >
          {label}
        </SignUpStepIndicator>
      ))}
    </div>
  );
};
